import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { SERVICES_DATA, SEO_CONFIG } from '../data/companyData';

export default function NotFoundPage() {
  return (
    <>
      <SEOHead
        title={SEO_CONFIG.notFound.title}
        description={SEO_CONFIG.notFound.description}
      />

      <section className="min-h-[70vh] flex items-center justify-center py-20 bg-neutral-50 px-4">
        <div className="max-w-2xl mx-auto text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-[#FAF6ED] border border-[#EAD5A5] text-[#8D6D2F] text-3xl font-extrabold shadow-sm">
            404
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-neutral-950">
            Siden blev ikke fundet
          </h1>

          <p className="text-base text-neutral-600 max-w-lg mx-auto leading-relaxed">
            Den side, du forsøger at tilgå, er enten flyttet, slettet eller findes ikke. Brug navigationen herunder til at komme videre.
          </p>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3 rounded-lg bg-neutral-950 hover:bg-[#20252D] text-white font-semibold text-sm transition-all shadow-sm"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/ydelser"
              className="w-full sm:w-auto px-6 py-3 rounded-lg bg-white hover:bg-neutral-100 text-neutral-900 font-semibold text-sm transition-all border border-neutral-300"
            >
              Se vores ydelser
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto px-6 py-3 rounded-lg bg-[#C5A059] hover:bg-[#DFBF77] text-neutral-950 font-bold text-sm transition-all shadow-sm"
            >
              Kontakt os
            </Link>
          </div>

          {/* Quick Service Links */}
          <div className="pt-8 border-t border-neutral-200">
            <span className="text-xs font-bold text-neutral-500 uppercase tracking-wider block mb-4">
              Populære arbejdsområder
            </span>
            <div className="flex flex-wrap justify-center gap-2">
              {SERVICES_DATA.slice(0, 5).map((s) => (
                <Link
                  key={s.slug}
                  to={`/ydelser/${s.slug}`}
                  className="px-3 py-1.5 rounded-lg bg-white border border-neutral-200 text-xs font-medium text-neutral-700 hover:text-neutral-950 hover:border-[#C5A059] transition-all"
                >
                  {s.shortTitle}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
